import React, { useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import placeholder from '@assets/images/loading-header.png';
import { getImageMenu } from '@services/images.service';
import Image from '@components/Image';
import ErrorImage from '@components/Image/components/ErrorImage';
import { PRODUCT_CLICK_LOCATION } from '@conversion/constants';

const SIZE = 75;

const Container = styled.div`
  height: ${SIZE}px;
  min-width: ${SIZE}px;
  width: 100%;
  margin-left: ${({ theme }) => theme.spacing(6)};
  border-radius: 6px;
`;

const StyledImage = styled(Image)`
  width: ${SIZE}px;
  height: ${SIZE}px;
  border-radius: 6px;
`;

const ProductImage = ({ image, name }) => {
  const productImage = useMemo(
    () =>
      getImageMenu({
        image,
        width: SIZE,
        height: SIZE,
      }),
    [image],
  );

  if (!image) return <ErrorImage />;

  return (
    <Container>
      <StyledImage
        id={PRODUCT_CLICK_LOCATION.PHOTO}
        src={productImage}
        placeholder={placeholder}
        alt={name}
        showErrorImage
      />
    </Container>
  );
};

ProductImage.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string.isRequired,
};

export default memo(ProductImage);
